import React from 'react';
import {
  Box,
  Icon,
  TabContent,
  TabGroup,
  TabItem,
  Typography,
} from '@saviynt/design-system';

import { type IdentityProvider } from '../../../shared/types';
import { useInvertedLocalize } from '../../../shared/utils/localization';

import { SSOKeySettings } from './SSOKeySettings';
import { SSOListView } from './SSOListView';
import { SSOSettings } from './SSOSettings';

import './SSOTabView.css';

enum Tabs {
  providers = 'providers',
  settings = 'settings',
  keys = 'keys',
}

interface Props {
  providers: IdentityProvider[];
  reloadProviders: () => void;
}

/** Tab switching UI for SSO Config Page */
export default function SSOTabView({
  providers,
  reloadProviders,
}: Props): JSX.Element {
  const l = useInvertedLocalize();
  const [activeTab, setActiveTab] = React.useState(Tabs.providers);

  return (
    <main className='Auth_SSOTabView'>
      <Box className='Auth_SSOTabView_headerPanel'>
        <Typography kind='h1' className='Auth_SSOTabView_header'>
          {l('SSO Providers')}
        </Typography>
        <TabGroup
          value={activeTab}
          onChange={(value: Tabs) => setActiveTab(value)}>
          <TabItem
            icon={<Icon kind='UserManagement' />}
            label={l('Providers')}
            value={Tabs.providers}
          />
          <TabItem
            icon={<Icon kind='Settings' />}
            label={l('Settings')}
            value={Tabs.settings}
          />
          <TabItem
            icon={<Icon kind='Credentials' />}
            label={l('Keys')}
            value={Tabs.keys}
          />
        </TabGroup>
      </Box>
      <Box className='Auth_SSOTabView_mainArea'>
        <TabContent value={activeTab} tabValue={Tabs.providers}>
          <SSOListView
            providers={providers}
            reloadProviders={reloadProviders}
          />
        </TabContent>
        <TabContent value={activeTab} tabValue={Tabs.settings}>
          <SSOSettings />
        </TabContent>
        <TabContent value={activeTab} tabValue={Tabs.keys}>
          <SSOKeySettings />
        </TabContent>
      </Box>
    </main>
  );
}
